<template>
  <div class="mysterious-lottery-page">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      :title="t('mysteriousLottery.title')"
      safe-area-inset-top
      :border="false"
      left-arrow

      class="custom-nav-bar nav-bar-fixed"
    >
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>

    <!-- 内容区域 -->
    <div class="content-container">
      <!-- Banner 区域 -->
      <div class="banner-section">
        <img  :src="getAssetsFile('activity/mysterious/mysterious-banner@2x.png')" alt="" class="w-full h-full">
      </div>

      <!-- 天数选择区域 -->
      <div class="days-section">
        <div class="days-container">
          <div
            v-for="(day, index) in daysList"
            :key="index"
            class="day-item"
            :class="{ 'active': selectedDay === index }"
            @click="selectDay(index)"
          >
            <div class="day-icon">
              <!-- 背景图片 -->
              <img
                :src="getAssetsFile(`/activity/mysterious/maijs (${selectedDay === index ? 1 : 2}).png`)"
                alt="background"
                class="icon-background"
              />
              <!-- 面具图片 -->
              <img
                :src="getAssetsFile(`/activity/mysterious/maijs (${day.maskIndex}).png`)"
                alt="mask"
                class="icon-mask"
              />
              <!-- 可领取提示红点 -->

              <div
                v-if="day.config?.claimReward"
                class="red-dot"
              ></div>
            </div>
            <div class="day-text" :class="{ 'active-text': selectedDay === index }">
              {{ day.label }}
            </div>
            <!-- 选中状态的箭头 -->
            <div v-if="selectedDay === index" class="day-arrow">
              <div class="arrow-down"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 信息盒子 -->
      <div class="info-box">
        <div class="info-section">
          <div class="info-row">
            <div class="info-left">
              <img  :src="getAssetsFile('activity/mysterious/icons (1).png')" alt="" class="w-[15px] h-[15px]">
              <span class="info-label">{{ t('mysteriousLottery.registrationTime') }}</span>
            </div>
            <span class="info-value">{{ formatDateTime(datalist.joinTime) }}</span>
          </div>
          <div class="info-row">
            <div class="info-left">
              <img  :src="getAssetsFile('activity/mysterious/icons (2).png')" alt="" class="w-[15px] h-[15px]">
              <span class="info-label">{{ t('mysteriousLottery.totalDepositDays', { days: currentDayConfig?.day || 15 }) }}</span>
            </div>
              <span class="info-value">{{ VITE_symbol }}{{ formatAmount(currentDayConfig?.recharge || 0) }}</span>
          </div>
        </div>

        <div class="bg-[#004D37] p-[23px] rounded-[10px]">
          <div class="claim-title">{{ t('mysteriousLottery.bonusClaimTime') }}</div>

          <!-- 上下排列的两个图标 -->
          <div class="icons-vertical">
            <div class="icon-item">
              <img :src="getAssetsFile('activity/mysterious/icons (4).png')" alt="" class="w-[15px] h-[15px]">
              <span class="color-[#6691D5] text-[17px]">{{ formatDateTime(currentDayConfig?.time) }}</span>
            </div>
            <div class="icon-item">
              <img :src="getAssetsFile('activity/mysterious/icons (3).png')" alt="" class="w-[15px] h-[15px]">
              <span class="text-white">{{ t('mysteriousLottery.mysteriousPrize') }}</span>
            </div>
          </div>

          <!-- 金额部分单独处理，保持居中 -->
          <div class="prize-amount">
            <span  class="text-[14px] color-[#FFFFFF] ">{{ VITE_symbol }}</span> {{ formatAmount(currentDayConfig?.showReward || 0) }}
          </div>
        </div>
      </div>

      <!-- 奖励表格 -->
      <div class="table-section">
        <div class="table-container">
          <div class="table-header">
            <div class="header-cell">{{ t('mysteriousLottery.depositRange') }}</div>
            <div class="header-cell">{{ t('mysteriousLottery.mysteriousPrize') }}</div>
          </div>
          <div
            v-for="(row, index) in currentDayConfig?.rewardConfigs || []"
            :key="index"
            class="table-row"
            :class="{ 'zebra-stripe': index % 2 === 1 }"
          >
            <div class="table-cell deposit-cell">{{ VITE_symbol }} {{ formatAmount(row.recharge) }}</div>
            <div class="table-cell prize-cell">{{ VITE_symbol }} {{ formatAmount(row.lowShowReward) }} ~ {{ formatAmount(row.highShowReward) }}</div>
          </div>
        </div>
      </div>

      <!-- 活动规则和领取按钮 -->
      <div class="rules-section">
        <div class="rules-container">
          <div class="rules-title">{{ t('mysteriousLottery.activityRules') }}</div>
          <div class="rule-text mt-[20px] mb-[5px]">{{ t('mysteriousLottery.eventDetails') }}:</div>

          <div class="rules-list">
            <div class="rule-item">
              <span class="rule-number">1.</span>
              <span class="rule-text">{{ t('mysteriousLottery.rule1') }}</span>
            </div>
            <div class="rule-item">
              <span class="rule-number">2.</span>
              <span class="rule-text">{{ t('mysteriousLottery.rule2') }}</span>
            </div>
            <div class="rule-item">
              <span class="rule-number">3.</span>
              <span class="rule-text">{{ t('mysteriousLottery.rule3') }}</span>
            </div>
            <div class="rule-item">
              <span class="rule-number">4.</span>
              <span class="rule-text">{{ t('mysteriousLottery.rule4') }}</span>
            </div>
            <div class="rule-item">
              <span class="rule-number">5.</span>
              <span class="rule-text">{{ t('mysteriousLottery.rule5') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 领取按钮 -->
    <div class="claim-button-container">
      <!-- <div class="w-full h-[1px] bg-[#00A97E]"></div> -->
      <div
        class="claim-button"
        :class="{ 'disabled': !currentDayConfig?.claimReward }"
        @click="handleClaim"
      >
        {{ t('mysteriousLottery.claim') }}
      </div>
    </div>

    <!-- RewardDialog 组件 -->
    <RewardDialog
      v-model:show="showRewardDialog"
      :amount="rewardAmount"
      @confirm="handleRewardConfirm"
    />
  </div>
</template>

<script setup lang="ts">
import { Button } from "@/components/Button"
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { getAssetsFile } from '@/utils/pub-use'
import { getMysteriousGoldActivity, receiveMysteriousGoldActivity } from '@/api/game'
import RewardDialog from '@/components/RewardDialog.vue'
import dayjs from "dayjs"
const router = useRouter()
const { t } = useI18n()
const VITE_symbol = import.meta.env.VITE_SYMBOL

// 接口数据
const datalist = ref<any>({})

// 选中的天数索引
const selectedDay = ref(0) // 默认选中第一个

// RewardDialog 相关状态
const showRewardDialog = ref(false)
const rewardAmount = ref<any>({})

// 计算属性：当前选中的天数配置
const currentDayConfig = computed(() => {
  return datalist.value.appDayConfigs?.[selectedDay.value] || null
})

// 计算属性：天数列表，从接口数据生成
const daysList = computed(() => {
  if (!datalist.value.appDayConfigs) return []

  return datalist.value.appDayConfigs.map((config: any, index: number) => {
    // 根据天数生成标签，使用多语言
    const dayLabel = t('mysteriousLottery.dayLabel', { day: config.day })

    // 根据索引设置面具图片索引（保持原有的逻辑）
    const maskIndexMap = [7, 6, 5, 4, 3]
    const maskIndex = maskIndexMap[index] || 3

    return {
      label: dayLabel,
      value: config.day,
      maskIndex: maskIndex,
      config: config
    }
  })
})

// 格式化金额
const formatAmount = (amount: number) => {
  if (!amount) return '0,00'
  return amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

// 格式化日期时间
const formatDateTime = (dateTime: string) => {
  if (!dateTime) return ''
  const date = dayjs(dateTime)
  return date.format('YYYY-MM-DD HH:mm:ss A')
}

// 选择天数
const selectDay = (index: number) => {
  selectedDay.value = index
}

// 计算应该选中的天数索引
const calculateSelectedDay = () => {
  if (!datalist.value.appDayConfigs) return 0

  const now = new Date()
  console.log('当前时间:', now)
  console.log('接口数据:', datalist.value.appDayConfigs)

  // 遍历所有配置，找到应该选中的索引
  for (let i = 0; i < datalist.value.appDayConfigs.length; i++) {
    const config = datalist.value.appDayConfigs[i]
    if (!config.time) continue

    const configTime = new Date(config.time)
    console.log(`配置${i}的时间:`, configTime, '当前时间:', now)

    // 如果当前时间还没到这个配置的时间，选中上一个（或第一个）
    if (now < configTime) {
      const selectedIndex = i > 0 ? i - 1 : 0
      console.log('还没到时间，选中上一个:', selectedIndex)
      return selectedIndex
    }
  }

  // 如果所有时间都已经过了，选中最后一个
  const lastIndex = datalist.value.appDayConfigs.length - 1
  console.log('所有时间都过了，选中最后一个:', lastIndex)
  return lastIndex
}

// 领取按钮处理
const handleClaim = async () => {
  // 检查当前天数是否可领取
  if (currentDayConfig.value?.claimReward) {
    try {
      console.log('领取神秘奖励', currentDayConfig.value)
      const res = await receiveMysteriousGoldActivity(currentDayConfig.value.day)
      console.log('领取神秘奖励结果:', res)

      // 设置奖励金额并显示弹窗
      rewardAmount.value = res.data || {
        reward: currentDayConfig.value.showReward,
      }
      showRewardDialog.value = true

      // 重新获取活动数据以更新状态
      await getMysteriousGoldActivity().then(response => {
        datalist.value = response.data
      })
    } catch (error) {
      console.error('领取神秘奖励失败:', error)
    }
  } else {
    console.log('当前天数不可领取奖励')
  }
}

// 处理奖励确认
const handleRewardConfirm = () => {
  // 弹窗确认后的处理逻辑
  console.log('奖励确认完成')
}

// 返回上一页
const onClickLeft = () => {
  router.back()
}

onMounted(() => {
  getMysteriousGoldActivity().then(res => {
    datalist.value = res.data
    console.log('接口数据:', res.data)

    // 根据当前时间设置选中的天数
    selectedDay.value = calculateSelectedDay()
  })
})
</script>

<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.3), 0px -2px 22px 0px rgba(53,189,128,0.61);
  &>* {
    height: 100%;
  }
}
.mysterious-lottery-page {
  background: #006849;
  color: white;
}

.nav-bar-fixed {
  --van-nav-bar-background: #006849;
  --van-nav-bar-icon-color: #fff;
  --van-nav-bar-text-color: #fff;
  --van-nav-bar-title-text-color: #fff;
  position: sticky;
  top: 0;
  z-index: 100;
}

.content-container {
  padding: 0 10px;
}

/* Banner 区域 */
.banner-section {
  position: relative;
}

.banner-bg {
  height:190px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ffa500 50%, #ff1493 100%);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-placeholder {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
}

.banner-title {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px;
  font-weight: bold;
  color: #FFD700;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  line-height: 1.2;
}

/* 天数选择区域 */
.days-section {
  padding: 15px 0;padding-top: 0;
}

.days-container {
  display: flex;
  justify-content: space-between;
  gap: 25px;
  padding: 0;
}

.day-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.day-icon {
  width: 50px;
  height: 50px;
  margin-bottom: 8px;
  position: relative;
}

/* 可领取提示红点 */
.red-dot {
  position: absolute;
  top: 8px;
  right: 5px;
  width: 8px;
  height: 8px;
  background-color: #ff4444;
  border-radius: 50%;
  z-index: 10;
}

.icon-background {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: contain;
}

.icon-mask {
  width: 65%;
  height: 65%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: contain;
  z-index: 1;
}

.day-text {
  font-size: 12px;
  color: #619184;
  transition: color 0.3s ease;
  margin-bottom: 5px;
}

.day-text.active-text {
  color: #17B663;
  font-weight: bold;
}

/* 选中状态的箭头 */
.day-arrow {
  display: flex;
  justify-content: center;
  margin-top: 5px;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid #17B663;
}

/* 信息盒子 */
.info-box {
  background: #085b3c;
  border-radius: 8px;
  padding: 16px;
  margin: 0 0;
  position: relative;
}

.info-section {
  margin-bottom: 12px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 12px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-label {
  color: white;
  font-size: 14px;
}

.info-value {
  color: white;
  font-weight: 500;
}

.claim-title {
  color: white;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 8px;
  line-height: 1.3;
  text-align: center;
}

/* 上下排列的图标容器 */
.icons-vertical {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
  margin-left: 40px; /* 往右边移动30px */
}

.icon-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.prize-amount {
  color: #FFA930;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
  margin-top: 8px;
  margin-right: 60px; /* 重置左边距，保持居中 */
}

/* 表格区域 */
.table-section {
  margin-top: 20px;
}

.table-container {
  background: #004D37;
  border-radius: 8px;
  overflow: hidden;
}

.table-header {
  display: flex;
  background: #00422F;
}

.header-cell {
  flex: 1;
  padding: 12px 8px;
  text-align: center;
  font-weight: bold;
  color: #ffffff;
  font-size: 14px;
}

.table-row {
  display: flex;
  background: #006849;
}

.table-row.zebra-stripe {
  background: #00422F;
}

.table-cell {
  flex: 1;
  padding: 10px 8px;
  text-align: center;
  font-size: 13px;
}

.deposit-cell {
  color: #ffffff;
}

.prize-cell {
  color: #FFA930;
  font-weight: 500;
}

/* 活动规则区域 */
.rules-section {
  margin-top: 20px;
}

.rules-container {
  border-radius: 8px;
  padding: 20px;
}

.rules-title {
  color: #ffffff;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 8px;
  text-align: left;
}

.rules-subtitle {
  color: #ffffff;
  font-size: 12px;
  margin-bottom: 16px;
  text-align: left;
}

.rules-list {
  margin-bottom: 20px;
}

.rule-item {
  display: flex;
  margin-bottom: 12px;
  line-height: 1.4;
}

.rule-number {
  color: #ffffff;
  flex-shrink: 0;
  font-size: 12px;
}

.rule-text {
  color: #ffffff;
  font-size: 12px;
  flex: 1;
}

.claim-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;
  width: 100%;
  position: fixed;
  bottom: 10px;
  left: 0;
  right: 0;
  /* background: #006849; */
  z-index: 100;
}

.claim-button {
  background: linear-gradient(70deg, #13C769 0%, #1C9755 100%);
  color: #ffffff;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 90%;
  margin-top: 30px;
  z-index: 9999 !important;
  height: 44px;
  text-align: center;
  line-height: 44px;
}

/* 禁用状态的样式 - 渐变色 */
.claim-button.disabled {
  background: linear-gradient(90deg, #1A7A47 0%, #1B7B4C 100%);
  color: #8FA89F;
  cursor: not-allowed;
}

/* 可选：添加悬停效果 */
.claim-button:not(.disabled):hover {
  background: linear-gradient(70deg, #15D973 0%, #1EA85F 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(19, 199, 105, 0.3);
}

.claim-button:not(.disabled):active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(19, 199, 105, 0.2);
}

</style>
